import React from 'react';
import PropTypes from 'prop-types';
import Symbol from '../../webcommon/common/symbols/Symbol';
import HeaderSortDisplay from '../../webcommon/grid/gridcomponents/HeaderSortDisplay';
import classnames from 'classnames';
import defaultStyles from './SortableSymbol.module.scss';

const SortableSymbol = props => (
    <div className={ classnames({
        [props.styles.sortableSymbol]: true,
        [props.styles.alignRight]: props.alignRight
    }) }
    >
        <Symbol symbol={ props.symbol }>{props.title}</Symbol>
        <HeaderSortDisplay styles={ props.gridStyles } />
    </div>
);

SortableSymbol.propTypes = {
    alignRight: PropTypes.bool,
    gridStyles: PropTypes.objectOf(PropTypes.string).isRequired,
    symbol: PropTypes.string,
    title: PropTypes.string,
    styles: PropTypes.objectOf(PropTypes.string)
};

SortableSymbol.defaultProps = {
    alignRight: false,
    symbol: '',
    title: '',
    styles: defaultStyles
};

export default SortableSymbol;
